import { lazy } from 'react';

const AppRoutes = [
  {
    path: 'monitoring',
    component: lazy(() => import('pages/monitoring')),
  },
  {
    path: 'reports',
    component: lazy(() => import('pages/reports')),
  },
  {
    path: 'reports/show/:id',
    component: lazy(() => import('pages/reports/show')),
  },
  {
    path: 'departaments',
    component: lazy(() => import('pages/departament')),
  },
  {
    path: 'departament/:id',
    component: lazy(() => import('pages/departament/show')),
  },
  {
    path: 'vehicle',
    component: lazy(() => import('pages/car')),
  },
  {
    path: 'access',
    component: lazy(() => import('pages/access')),
  },
  {
    path: 'server',
    component: lazy(() => import('pages/server')),
  },
  {
    path: 'tanks',
    component: lazy(() => import('pages/sensor')),
  },
  {
    path: 'user',
    component: lazy(() => import('pages/users')),
  },
];

export default AppRoutes;
